/**
 * Shipping Protection — cart toggle (variant 67747172450611).
 * Prefixed ship-prot. Uses document-level delegation (drawer re-renders wipe nodes).
 * Does not patch window.fetch.
 *
 * In-flight lock lives in module scope (survives drawer re-renders that replace the
 * button). Clicks during flight store a last-wins intention applied when free.
 */
(function () {
  if (window.__shipProtLoaded) return;
  window.__shipProtLoaded = true;

  var STORAGE_KEY = 'ml_ship_prot_optout';
  var VARIANT_FALLBACK = 67747172450611;
  /** Module-scoped in-flight lock — not the button's disabled/aria-busy (those are visual only). */
  var emVoo = false;
  /** Last desired action while busy: 'add' | 'remove' | null. Last click wins; no queue. */
  var intencao = null;
  /** Optimistic on/off while a request is in flight (re-applied after DOM swap). */
  var desejoVisual = null;
  var syncTimer = null;
  var lastSyncAt = 0;
  /** Ignore MutationObserver ticks caused by our own section swaps. */
  var skipObserver = false;
  /** Known protection-line presence in this page session: null | true | false. */
  var protKnown = null;
  /** Set on checkout click so we stop fighting Zipify's cart.js polling. */
  var checkoutGoing = false;
  /** True while we dispatch cart events so we do not re-enter reconcile. */
  var selfEvent = false;

  function hushObserver() {
    skipObserver = true;
    setTimeout(function () {
      if (!checkoutGoing) skipObserver = false;
    }, 700);
  }

  function cartFromPayload(payload) {
    if (!payload) return null;
    if (payload.items && Array.isArray(payload.items)) return payload;
    if (payload.cart && payload.cart.items) return payload.cart;
    if (payload.cartData && payload.cartData.items) return payload.cartData;
    return null;
  }

  function rootPath() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function routes() {
    var r = window.routes || {};
    var root = rootPath();
    return {
      add: r.cart_add_url || root + 'cart/add.js',
      change: r.cart_change_url || root + 'cart/change.js',
      update: r.cart_update_url || root + 'cart/update.js',
      cart: r.cart_url || root + 'cart.js',
      cartJs: root + 'cart.js',
    };
  }

  function getRoot() {
    return document.querySelector('[data-ship-prot-root]');
  }

  function getAllRoots() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-ship-prot-root]'));
  }

  function getSwitches() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-ship-prot-switch]'));
  }

  function readConfig(el) {
    el = el || getRoot();
    if (!el) return null;
    return {
      variantId: parseInt(el.getAttribute('data-ship-prot-variant-id'), 10) || VARIANT_FALLBACK,
      country: (el.getAttribute('data-ship-prot-country') || '').toUpperCase(),
      optInMarket: el.getAttribute('data-ship-prot-opt-in-market') === 'true',
      priceLabel: el.getAttribute('data-ship-prot-price') || '$3.99',
      inCart: el.getAttribute('data-ship-prot-in-cart') === 'true',
      lineKey: el.getAttribute('data-ship-prot-line-key') || '',
      qty: parseInt(el.getAttribute('data-ship-prot-qty'), 10) || 0,
      otherCount: parseInt(el.getAttribute('data-ship-prot-other-count'), 10) || 0,
    };
  }

  function cartToken() {
    var m = document.cookie.match(/(?:^|;\s*)cart=([^;]+)/);
    return m ? decodeURIComponent(m[1]).split('?')[0] : '';
  }

  /** Opt-out is bound to the cart token: a new cart starts pre-checked again. */
  function hasOptOut() {
    try {
      var v = window.localStorage.getItem(STORAGE_KEY);
      if (!v) return false;
      var tok = cartToken();
      if (v !== '1' && tok && v !== tok) {
        window.localStorage.removeItem(STORAGE_KEY);
        return false;
      }
      return true;
    } catch (e) {
      return false;
    }
  }

  function setOptOut(value) {
    try {
      if (value) {
        window.localStorage.setItem(STORAGE_KEY, cartToken() || '1');
      } else {
        window.localStorage.removeItem(STORAGE_KEY);
      }
    } catch (e) {
      /* ignore */
    }
  }

  /** Visual busy only — real lock is `emVoo` in the closure. */
  function setSwitchesBusy(isBusy) {
    getSwitches().forEach(function (btn) {
      if (isBusy) {
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('aria-busy', 'true');
      } else {
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-busy');
      }
    });
  }

  function priceFromConfig(cfg) {
    return (cfg && cfg.priceLabel) || (readConfig() && readConfig().priceLabel) || '$3.99';
  }

  /** Re-apply optimistic UI after the theme replaces the drawer markup. */
  function reaplicarEstadoAposRender() {
    var cfg = readConfig();
    var price = priceFromConfig(cfg);

    if (intencao) {
      setSwitchesState(intencao === 'add', price);
      if (emVoo) setSwitchesBusy(true);
      else processIntention();
      return true;
    }

    if (emVoo && desejoVisual !== null) {
      setSwitchesState(!!desejoVisual, price);
      setSwitchesBusy(true);
      return true;
    }

    return false;
  }

  function setSwitchesState(on, priceLabel) {
    var price = priceLabel || (readConfig() && readConfig().priceLabel) || '$3.99';
    getSwitches().forEach(function (btn) {
      btn.setAttribute('aria-checked', on ? 'true' : 'false');
      if (on) {
        btn.setAttribute('data-ship-prot-on', '');
        btn.setAttribute('aria-label', 'Remove shipping protection (' + price + ')');
      } else {
        btn.removeAttribute('data-ship-prot-on');
        btn.setAttribute('aria-label', 'Add shipping protection for ' + price);
      }
    });
    getAllRoots().forEach(function (root) {
      root.setAttribute('data-ship-prot-in-cart', on ? 'true' : 'false');
    });
  }

  function collectSectionIds() {
    var ids = [];
    var seen = {};

    function add(id) {
      if (!id || seen[id]) return;
      seen[id] = true;
      ids.push(id);
    }

    // Static cart drawer section
    add('cart-drawer');
    add('cart-icon-bubble');

    // Header / icon bubble wrappers
    var headerSection = document.querySelector('#shopify-section-header, .shopify-section-header');
    if (headerSection && headerSection.id) {
      add(headerSection.id.replace(/^shopify-section-/, ''));
    }

    var cartDrawerEl = document.querySelector('cart-drawer');
    if (cartDrawerEl) {
      var drawerSection = cartDrawerEl.closest('.shopify-section');
      if (drawerSection && drawerSection.id) {
        add(drawerSection.id.replace(/^shopify-section-/, ''));
      }
    }

    // Cart page sections
    var footer = document.getElementById('main-cart-footer');
    if (footer && footer.dataset && footer.dataset.id) add(footer.dataset.id);

    var items = document.getElementById('main-cart-items');
    if (items && items.dataset && items.dataset.id) add(items.dataset.id);

    document.querySelectorAll('.shopify-section[id*="cart"]').forEach(function (sec) {
      if (sec.id) add(sec.id.replace(/^shopify-section-/, ''));
    });

    return ids;
  }

  function sectionsParam() {
    // Cart AJAX API expects an array of section ids (Dawn/Shrine).
    return collectSectionIds();
  }

  function sectionsQuery() {
    return collectSectionIds().join(',');
  }

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function replaceInner(target, sourceDoc, selector) {
    if (!target) return;
    var next = sourceDoc.querySelector(selector);
    if (!next) return;
    target.innerHTML = next.innerHTML;
  }

  function replaceElement(target, sourceDoc, selector) {
    if (!target) return;
    var next = sourceDoc.querySelector(selector);
    if (!next) return;
    target.innerHTML = next.innerHTML;
    // copy relevant attributes for empty state classes etc.
    if (next.className) target.className = next.className;
  }

  function applySectionHTML(id, html) {
    if (!html) return;
    var doc = parseHTML(html);

    // Cart drawer: replace the whole cart-drawer node contents / element
    if (id === 'cart-drawer' || id.indexOf('cart-drawer') !== -1) {
      var liveDrawer = document.querySelector('cart-drawer');
      var nextDrawer = doc.querySelector('cart-drawer');
      if (liveDrawer && nextDrawer) {
        // Section Rendering returns the closed drawer markup (no `active`).
        // Preserve open/runtime state classes so a content refresh does not slam it shut.
        var preserved = [];
        var liveClassList = liveDrawer.className ? liveDrawer.className.split(/\s+/) : [];
        for (var ci = 0; ci < liveClassList.length; ci++) {
          var c = liveClassList[ci];
          if (!c) continue;
          if (
            c === 'active' ||
            c === 'animate' ||
            c.indexOf('is-') === 0 ||
            c.indexOf('js-') === 0
          ) {
            preserved.push(c);
          }
        }
        var hadOpenAttr = liveDrawer.hasAttribute('open');

        liveDrawer.innerHTML = nextDrawer.innerHTML;
        liveDrawer.className = nextDrawer.className;

        // Empty cart: let the theme close as usual (do not force open).
        // `is-empty` from the new HTML / dispatchThemeEvents is authoritative.
        var cartEmpty =
          (nextDrawer.className &&
            (' ' + nextDrawer.className + ' ').indexOf(' is-empty ') !== -1) ||
          nextDrawer.classList.contains('is-empty');

        if (!cartEmpty) {
          for (var pi = 0; pi < preserved.length; pi++) {
            var pc = preserved[pi];
            if (pc === 'is-empty') continue;
            if (!liveDrawer.classList.contains(pc)) liveDrawer.classList.add(pc);
          }
          if (hadOpenAttr && !liveDrawer.hasAttribute('open')) {
            liveDrawer.setAttribute('open', '');
          }
        }
        return;
      }
      var liveSection = document.getElementById('shopify-section-' + id);
      var nextSection = doc.getElementById('shopify-section-' + id) || doc.querySelector('.shopify-section');
      if (liveSection && nextSection) {
        liveSection.innerHTML = nextSection.innerHTML;
        return;
      }
    }

    // Cart icon bubble
    if (id === 'cart-icon-bubble' || id.indexOf('cart-icon-bubble') !== -1) {
      var liveBubble = document.getElementById('shopify-section-cart-icon-bubble') ||
        document.getElementById('cart-icon-bubble') ||
        document.querySelector('#cart-icon-bubble');
      var nextBubble =
        doc.getElementById('shopify-section-cart-icon-bubble') ||
        doc.getElementById('cart-icon-bubble') ||
        doc.querySelector('#cart-icon-bubble') ||
        doc.querySelector('.shopify-section');
      if (liveBubble && nextBubble) {
        if (liveBubble.id === 'cart-icon-bubble' || liveBubble.matches('#cart-icon-bubble')) {
          liveBubble.innerHTML = nextBubble.innerHTML;
        } else {
          liveBubble.innerHTML = nextBubble.innerHTML;
        }
        return;
      }
      // Bubble may live inside header
      var headerBubble = document.querySelector('#cart-icon-bubble');
      var srcBubble = doc.querySelector('#cart-icon-bubble');
      if (headerBubble && srcBubble) {
        headerBubble.innerHTML = srcBubble.innerHTML;
      }
      return;
    }

    // Generic shopify-section swap
    var live = document.getElementById('shopify-section-' + id);
    var next = doc.getElementById('shopify-section-' + id) || doc.querySelector('.shopify-section');
    if (live && next) {
      live.innerHTML = next.innerHTML;
      return;
    }

    // main-cart-footer by element id
    if (id === 'cart-footer' || id.indexOf('cart-footer') !== -1 || id.indexOf('main-cart-footer') !== -1) {
      replaceElement(document.getElementById('main-cart-footer'), doc, '#main-cart-footer');
    }
    if (id === 'cart-items' || id.indexOf('cart-items') !== -1 || id.indexOf('main-cart-items') !== -1) {
      replaceElement(document.getElementById('main-cart-items'), doc, '#main-cart-items');
      // Some themes wrap items differently
      var jsContents = document.querySelector('#main-cart-items .js-contents, cart-items .js-contents');
      var nextJs = doc.querySelector('#main-cart-items .js-contents, cart-items .js-contents, .js-contents');
      if (jsContents && nextJs) jsContents.innerHTML = nextJs.innerHTML;
    }
  }

  /** Re-kick drawer thumbnails after a manual HTML swap (lazy imgs can stay blank). */
  function fixDrawerImages() {
    var imgs = document.querySelectorAll('cart-drawer img, #CartDrawer img');
    Array.prototype.forEach.call(imgs, function (img) {
      img.removeAttribute('loading');
      var src = img.getAttribute('src');
      var srcset = img.getAttribute('srcset');
      if (srcset) { img.removeAttribute('srcset'); img.setAttribute('srcset', srcset); }
      if (src) { img.removeAttribute('src'); img.setAttribute('src', src); }
      img.style.opacity = '';
    });
  }

  /**
   * Replace the drawer's inner #CartDrawer content (the <cart-drawer> element and its
   * listeners stay; our switch uses document delegation). Keeps the running cart timer text.
   */
  function swapDrawerInner(html) {
    var doc = parseHTML(html);
    var live = document.querySelector('cart-drawer #CartDrawer') || document.getElementById('CartDrawer');
    var next = doc.getElementById('CartDrawer') || doc.querySelector('#CartDrawer');
    if (!live || !next) return false;
    var oldTimer = live.querySelector('.cart-timer');
    var newTimer = next.querySelector('.cart-timer');
    live.innerHTML = next.innerHTML;
    // Keep the live timer node itself (its interval references it), not a copy.
    var placedTimer = live.querySelector('.cart-timer');
    if (oldTimer && placedTimer && placedTimer.parentNode) placedTimer.parentNode.replaceChild(oldTimer, placedTimer);
    cacheRow();
    try { console.log('[ship-prot] applied', { selector: 'cart-drawer #CartDrawer', inCart: (live.querySelector('[data-ship-prot-root]') || {getAttribute: function(){return null;}}).getAttribute('data-ship-prot-in-cart') }); } catch (e) {}
    var liveDrawer = document.querySelector('cart-drawer');
    var nextDrawer = doc.querySelector('cart-drawer');
    if (liveDrawer && nextDrawer) {
      liveDrawer.classList.toggle('is-empty', nextDrawer.classList.contains('is-empty'));
    }
    return true;
  }

  /** Prefer the theme's own drawer renderer (keeps its image/timer/upsell init). */
  function themeRenderDrawer(sections) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return false;
    if (!drawer.classList.contains('active')) return false; // renderContents may open the drawer
    var items = document.querySelector('cart-drawer-items');
    var need = [];
    try {
      need = (items && typeof items.getSectionsToRender === 'function' ? items.getSectionsToRender() : []).map(function (x) { return x.section || x.id; });
    } catch (e) { need = []; }
    if (!sections['cart-drawer']) return false;
    for (var i = 0; i < need.length; i++) if (!sections[need[i]]) return false;
    try {
      drawer.renderContents({ sections: sections, id: null });
      return true;
    } catch (e) {
      return false;
    }
  }

  function applySections(sections) {
    if (!sections) return;
    var st = startTimes && startTimes.get(sections);
    if (st && st < lastClickAt) {
      try { console.log('[ship-prot] dropped stale render', lastClickAt - st, 'ms older than last click'); } catch (e) {}
      return;
    }
    var drawerHtml = sections['cart-drawer'];
    if (drawerHtml && swapDrawerInner(drawerHtml)) {
      Object.keys(sections).forEach(function (id) {
        if (id.indexOf('cart-drawer') === -1) applySectionHTML(id, sections[id]);
      });
      fixDrawerImages();
      return;
    }
    if (false) {
      Object.keys(sections).forEach(function (id) {
        if (id.indexOf('cart-drawer') === -1) applySectionHTML(id, sections[id]);
      });
      setTimeout(fixDrawerImages, 0);
      return;
    }
    Object.keys(sections).forEach(function (id) {
      applySectionHTML(id, sections[id]);
    });
    fixDrawerImages();
  }

  function dispatchThemeEvents(cart) {
    selfEvent = true;
    try {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart || {} }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart || {} }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: cart || {} }));
    } catch (e) {
      /* ignore */
    }
    selfEvent = false;

    // Dawn / Shrine pub-sub
    try {
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'ship-prot', cart: cart });
      }
    } catch (e) {
      /* ignore */
    }

    // cart-drawer custom element hooks used by some themes
    try {
      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        if (cart && cart.item_count === 0) {
          drawer.classList.add('is-empty');
        } else if (cart) {
          drawer.classList.remove('is-empty');
        }
      }
    } catch (e) {
      /* ignore */
    }
  }

  function fetchSectionsOnly() {
    var ids = sectionsQuery();
    if (!ids || !ids.length) return Promise.resolve(null);
    // /cart is cheap; requesting sections on the current product URL re-renders the PDP.
    // Not /cart?sections: an app fetch wrapper (Zipify OCU) answers /cart* URLs with cart JSON.
    var url = rootPath() + '?sections=' + encodeURIComponent(ids) + '&_sp=' + Date.now();
    return xhrJSON('GET', url)
      .then(function (json) {
        // Guard: must be a sections map, not a cart object.
        if (!json || json.token || json.items) return null;
        return json;
      })
      .catch(function () {
        return null;
      });
  }

  function isCartPage() {
    return /\/cart\/?$/.test(window.location.pathname);
  }

  /** True while a user toggle batch runs: skip intermediate renders, render once at the end. */
  var batching = false;
  var lastDesiredOn = null;
  var REOPEN_KEY = 'ml_ship_prot_reopen';

  function drawerShowsProtection() {
    var r = document.querySelector('cart-drawer .cart-item--product-shipping-protection');
    return !!(r && r.style.display !== 'none');
  }

  /** Last resort: drawer still disagrees with what the user chose -> fix server cart via XHR, reload, reopen drawer. */
  function verifyDrawerOrReload(seq) {
    setTimeout(function () {
      if (seq !== renderSeq || intencao || emVoo || lastDesiredOn === null) return;
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) return;
      var want = lastDesiredOn;
      if (drawerShowsProtection() === want) {
        reconcileSubtotal().then(function (ok) {
          try { console.log('[ship-prot] verify ok', want, ok ? 'subtotal ok' : 'subtotal patched'); } catch (e) {}
        });
        return;
      }
      try { console.log('[ship-prot] verify mismatch -> xhr fix + reload', want); } catch (e) {}
      emVoo = true;
      var cfg = readConfig();
      var vid = (cfg && cfg.variantId) || VARIANT_FALLBACK;
      xhrJSON('GET', rootPath() + 'cart.js?_sp=' + Date.now())
        .then(function (cart) {
          var line = findProtectionLine(cart, vid);
          if (want && !line && otherItemCount(cart, vid) > 0) {
            return xhrJSON('POST', rootPath() + 'cart/add.js', { items: [{ id: vid, quantity: 1 }] });
          }
          if (!want && line) {
            return xhrJSON('POST', rootPath() + 'cart/change.js', { id: line.key, quantity: 0 });
          }
        })
        .catch(function () {})
        .then(function () {
          try { sessionStorage.setItem(REOPEN_KEY, '1'); } catch (e) {}
          window.location.reload();
        });
    }, 1200);
  }

  function reopenDrawerIfFlagged() {
    var flag = null;
    try { flag = sessionStorage.getItem(REOPEN_KEY); sessionStorage.removeItem(REOPEN_KEY); } catch (e) {}
    if (!flag) return;
    setTimeout(function () {
      var d = document.querySelector('cart-drawer');
      if (d && typeof d.open === 'function') { try { d.open(); return; } catch (e) {} }
      var icon = document.querySelector('#cart-icon-bubble');
      if (icon) icon.click();
    }, 400);
  }
  var renderSeq = 0;
  var cartPageLocked = false;

  function refreshUI(sectionsFromResponse, cart) {
    hushObserver();
    if (batching) return Promise.resolve(cart);
    if (isCartPage()) {
      // Cart page sections in this theme do not reliably re-render from our swap; reload for a fresh, correct page.
      window.location.reload();
      return new Promise(function () {});
    }
    if (sectionsFromResponse && Object.keys(sectionsFromResponse).length) {
      applySections(sectionsFromResponse);
      dispatchThemeEvents(cart);
      return Promise.resolve(cart);
    }
    return fetchSectionsOnly().then(function (sections) {
      hushObserver();
      if (sections) applySections(sections);
      dispatchThemeEvents(cart);
      return cart;
    });
  }

  function fetchCart() {
    return xhrJSON('GET', routes().cartJs + '?_sp=' + Date.now());
    return fetch(routes().cartJs + '?_sp=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' },
    }).then(function (res) {
      if (!res.ok) throw new Error('cart ' + res.status);
      return res.json();
    });
  }

  function findProtectionLine(cart, variantId) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].variant_id === variantId || String(items[i].id) === String(variantId)) {
        return items[i];
      }
    }
    return null;
  }

  function otherItemCount(cart, variantId) {
    var items = (cart && cart.items) || [];
    var n = 0;
    for (var i = 0; i < items.length; i++) {
      if (items[i].variant_id !== variantId && String(items[i].id) !== String(variantId)) {
        n += items[i].quantity;
      }
    }
    return n;
  }

  /** XMLHttpRequest helper: bypasses app fetch wrappers (Zipify OCU answers /cart* fetches itself). */
  var startTimes = typeof WeakMap === 'function' ? new WeakMap() : null;
  var lastClickAt = 0;
  function xhrJSON(method, url, body) {
    var started = Date.now();
    return new Promise(function (resolve, reject) {
      var x = new XMLHttpRequest();
      x.open(method, url, true);
      x.setRequestHeader('Accept', 'application/json');
      x.setRequestHeader('X-Ship-Prot', '1');
      if (body) x.setRequestHeader('Content-Type', 'application/json');
      x.onload = function () {
        var data = null;
        try { data = JSON.parse(x.responseText); } catch (e) {}
        if (data && typeof data === 'object' && startTimes) {
          startTimes.set(data, started);
          if (data.sections && typeof data.sections === 'object') startTimes.set(data.sections, started);
        }
        if (x.status >= 200 && x.status < 300) resolve(data);
        else {
          var err = new Error((data && data.description) || ('request ' + x.status));
          err.payload = data;
          reject(err);
        }
      };
      x.onerror = function () { reject(new Error('network')); };
      x.send(body ? JSON.stringify(body) : null);
    });
  }

  var lastOpResponse = null;
  function postJSON(url, body) {
    return xhrJSON('POST', url, body).then(function (data) {
      lastOpResponse = data;
      return data;
    });
  }

  /* ---------- Optimistic drawer UI (shown instantly, then replaced by the server render) ---------- */
  var cachedRowHTML = null;
  function protRow() {
    return document.querySelector('cart-drawer .cart-item--product-shipping-protection');
  }
  function cacheRow() {
    var r = protRow();
    if (r && r.style.display !== 'none') cachedRowHTML = r.outerHTML;
  }
  function bumpCounts(delta) {
    var bubble = document.getElementById('cart-icon-bubble');
    var walk = function (root, re) {
      if (!root) return;
      var tw = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = tw.nextNode())) {
        node.nodeValue = node.nodeValue.replace(re, function (m, n, rest) {
          var v = Math.max(0, parseInt(n, 10) + delta);
          if (typeof rest !== 'string') return String(v);
          var word = rest.replace(/s$/, '');
          return v + ' ' + (v === 1 ? word : word + 's');
        });
      }
    };
    walk(bubble, /^\s*(\d+)\s*$/);
    walk(bubble, /(\d+)\s+(items?)\b/);
    walk(document.querySelector('cart-drawer .drawer__heading'), /(\d+)(?=\s+products?\b)/);
  }
  function parseMoney(txt) {
    var m = String(txt || '').match(/(\d[\d.,\s]*)/);
    if (!m) return null;
    var raw = m[1].replace(/\s/g, '');
    var dec = /[.,]\d{2}$/.test(raw) ? raw.slice(-3, -2) : null;
    var digits = raw.replace(/[^\d]/g, '');
    var cents = dec ? parseInt(digits, 10) : parseInt(digits, 10) * 100;
    return { cents: cents, tpl: String(txt), num: m[1], dec: dec || '.', thou: dec === ',' ? '.' : ',' };
  }
  function formatLike(p, cents) {
    var neg = cents < 0; cents = Math.abs(Math.round(cents));
    var whole = String(Math.floor(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, p.thou);
    var out = whole + p.dec + String(cents % 100).padStart(2, '0');
    return p.tpl.replace(p.num.trim(), (neg ? '-' : '') + out);
  }
  function subtotalEl() {
    var rows = document.querySelectorAll('cart-drawer .cart-drawer__totals__row');
    for (var i = rows.length - 1; i >= 0; i--) {
      if (/subtotal/i.test(rows[i].textContent)) {
        var m = rows[i].querySelectorAll('.cart-drawer__totals__row__money');
        if (m.length) return m[m.length - 1];
      }
    }
    return null;
  }
  var protCentsCache = null;
  function protCents() {
    var row = protRow();
    var el = row && row.querySelector('.cart-item__final-price, .price--end.regular-price, .regular-price');
    var p = el && parseMoney(el.textContent);
    if (p && p.cents > 0) protCentsCache = p.cents;
    return protCentsCache;
  }
  function bumpSubtotal(sign) {
    var el = subtotalEl();
    var c = protCents();
    if (!el || !c) return;
    var p = parseMoney(el.textContent);
    if (!p) return;
    el.textContent = formatLike(p, p.cents + sign * c);
  }
  /** Patch subtotal text to cart.js total_price (cart currency). Returns true if it already matched. */
  function reconcileSubtotal() {
    return xhrJSON('GET', rootPath() + 'cart.js?_sp=' + Date.now()).then(function (cart) {
      var el = subtotalEl();
      if (!el || !cart || typeof cart.total_price !== 'number') return true;
      var p = parseMoney(el.textContent);
      if (!p) return true;
      if (p.cents === cart.total_price) return true;
      try { console.log('[ship-prot] subtotal patched', p.cents, '->', cart.total_price); } catch (e) {}
      el.textContent = formatLike(p, cart.total_price);
      return false;
    }).catch(function () { return true; });
  }

  function optimisticDrawer(on) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !drawer.classList.contains('active')) return;
    var row = protRow();
    var shown = !!(row && row.style.display !== 'none');
    if (on === shown) return;
    if (!on && row) {
      cachedRowHTML = row.outerHTML;
      protCents();
      row.style.display = 'none';
      bumpCounts(-1);
      bumpSubtotal(-1);
    } else if (on) {
      var first = document.querySelector('cart-drawer .cart-drawer-item');
      if (row) { row.style.display = ''; bumpCounts(1); bumpSubtotal(1); }
      else if (cachedRowHTML && first && first.parentNode) {
        var tmp = document.createElement('div');
        tmp.innerHTML = cachedRowHTML;
        if (tmp.firstElementChild) { first.parentNode.insertBefore(tmp.firstElementChild, first); bumpCounts(1); bumpSubtotal(1); }
      }
    }
    try { console.log('[ship-prot] optimistic', on); } catch (e) {}
  }

  function postJSONLegacy(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Ship-Prot': '1',
      },
      body: JSON.stringify(body),
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var err = new Error((data && data.description) || 'cart request failed');
          err.payload = data;
          throw err;
        }
        return data;
      });
    });
  }

  /**
   * Add protection without duplicating: if the line already exists, only clamp qty to 1.
   */
  function addProtection(variantId, knownCart) {
    hushObserver();
    var start = knownCart ? Promise.resolve(knownCart) : fetchCart();
    return start.then(function (cart) {
      var line = findProtectionLine(cart, variantId);
      if (line) {
        if (line.quantity !== 1) {
          return changeLine(line.key || line.id, 1);
        }
        return cart;
      }
      var addBody = { items: [{ id: variantId, quantity: 1 }] };
      if (!isCartPage()) {
        addBody.sections = sectionsParam();
        addBody.sections_url = '/cart';
      }
      return postJSON(routes().add, addBody).then(function (data) {
        protKnown = true;
        var added = (data && data.items && data.items[0]) || data;
        var qty = added && added.quantity;
        var key = added && (added.key || added.id);
        if (qty && qty > 1 && key) {
          return changeLine(key, 1);
        }
        return refreshUI(data.sections, data).then(function () {
          return data;
        });
      });
    });
  }

  function changeLine(lineKeyOrId, quantity) {
    hushObserver();
    var body = { quantity: quantity };
    if (!isCartPage()) {
      body.sections = sectionsParam();
      body.sections_url = '/cart';
    }
    // Prefer line item key when available
    if (lineKeyOrId && String(lineKeyOrId).indexOf(':') !== -1) {
      body.id = lineKeyOrId;
    } else {
      body.id = lineKeyOrId;
    }
    return postJSON(routes().change, body).then(function (data) {
      return refreshUI(data.sections, data).then(function () {
        return data;
      });
    });
  }

  function removeProtection(cart, variantId) {
    var line = findProtectionLine(cart, variantId);
    if (!line) return Promise.resolve(cart);
    return changeLine(line.key || line.id, 0);
  }

  function ensureQtyOne(cart, variantId) {
    var line = findProtectionLine(cart, variantId);
    if (!line) return Promise.resolve(cart);
    if (line.quantity <= 1) return Promise.resolve(cart);
    return changeLine(line.key || line.id, 1);
  }

  /**
   * Apply a single desired cart state ('add' | 'remove') against server truth.
   * Never duplicates the protection line.
   */
  function applyDesired(desired) {
    var cfg = readConfig();
    var variantId = (cfg && cfg.variantId) || VARIANT_FALLBACK;
    var price = priceFromConfig(cfg);

    // Always decide from live /cart.js (DOM attributes are stale while batching).
    setOptOut(desired !== 'add');
    return fetchCart().then(function (cart) {
      var line = findProtectionLine(cart, variantId);
      try { console.log('[ship-prot] toggle', desired, 'line:', !!line, 'items:', cart && cart.item_count); } catch (e) {}
      if (desired === 'add') {
        if (otherItemCount(cart, variantId) === 0) { protKnown = false; return cart; }
        if (line && line.quantity === 1) { protKnown = true; return cart; }
        if (line) return changeLine(line.key || line.id, 1);
        protKnown = true;
        return addProtection(variantId, cart);
      }
      protKnown = false;
      if (!line) {
        // cart.js may be stale (app fetch wrappers); fall back to the key rendered in the drawer.
        var domCfg = readConfig();
        if (domCfg && domCfg.inCart && domCfg.lineKey) return changeLine(domCfg.lineKey, 0).catch(function () { return cart; });
        return cart;
      }
      return changeLine(line.key || line.id, 0);
    });

    /* legacy path (unreachable) */
    if (desired === 'add') {
      setOptOut(false);
      if (protKnown === true && !(cfg && cfg.qty > 1)) {
        setSwitchesState(true, price);
        desejoVisual = true;
        return Promise.resolve(null);
      }
      if (cfg && cfg.otherCount === 0 && !cfg.inCart) {
        setSwitchesState(false, price);
        desejoVisual = false;
        protKnown = false;
        return Promise.resolve(null);
      }
      if (cfg && cfg.inCart && cfg.qty === 1 && cfg.lineKey) {
        setSwitchesState(true, price);
        desejoVisual = true;
        protKnown = true;
        return Promise.resolve(null);
      }
      if (cfg && cfg.lineKey && cfg.qty !== 1) {
        return changeLine(cfg.lineKey, 1).then(function (updated) {
          setSwitchesState(true, price);
          desejoVisual = true;
          protKnown = true;
          return updated;
        });
      }
      protKnown = true;
      return addProtection(variantId, { items: [] }).then(function (updated) {
        setSwitchesState(true, price);
        desejoVisual = true;
        return updated;
      });
    }

    setOptOut(true);
    if (cfg && cfg.lineKey) {
      protKnown = false;
      return changeLine(cfg.lineKey, 0).then(function (updated) {
        setSwitchesState(false, price);
        desejoVisual = false;
        return updated;
      });
    }
    if (cfg && !cfg.inCart && protKnown !== true) {
      protKnown = false;
      setSwitchesState(false, price);
      desejoVisual = false;
      return Promise.resolve(null);
    }

    return fetchCart().then(function (cart) {
      var line = findProtectionLine(cart, variantId);
      if (!line) {
        setSwitchesState(false, price);
        desejoVisual = false;
        return cart;
      }
      return removeProtection(cart, variantId).then(function (updated) {
        setSwitchesState(false, price);
        desejoVisual = false;
        return updated;
      });
    });
  }

  /**
   * Run the latest stored intention when no request is in flight.
   * After each request, drains a newer intention if one arrived mid-flight.
   */
  function processIntention() {
    if (emVoo) return;
    if (!intencao) return;

    var desired = intencao;
    lastDesiredOn = desired === 'add';
    lastOpResponse = null;
    intencao = null;
    emVoo = true;
    batching = true;
    desejoVisual = desired === 'add';
    setSwitchesState(desejoVisual, priceFromConfig(readConfig()));

    applyDesired(desired)
      .catch(function (err) {
        if (window.console && console.warn) {
          console.warn('[ship-prot] toggle', err);
        }
        // Reconcile visual with cart truth; do not leave the control stuck.
        return fetchCart()
          .then(function (cart) {
            var cfg = readConfig();
            var variantId = (cfg && cfg.variantId) || VARIANT_FALLBACK;
            var on = !!findProtectionLine(cart, variantId);
            protKnown = on;
            desejoVisual = on;
            setSwitchesState(on, priceFromConfig(cfg));
            return null;
          })
          .catch(function () {
            return null;
          });
      })
      .then(function () {
        emVoo = false;
        lastSyncAt = Date.now();

        if (intencao) {
          setSwitchesState(intencao === 'add', priceFromConfig(readConfig()));
          processIntention();
          return;
        }
        finalRender();
      });
  }

  /** One render after the last toggle request, from fresh /cart.js + section HTML. Stale results are dropped. */
  function finalRender() {
    var seq = ++renderSeq;
    if (isCartPage()) {
      cartPageLocked = true;
      setSwitchesBusy(true);
      window.location.reload();
      return;
    }
    emVoo = true;
    setSwitchesBusy(true);
    var op = lastOpResponse;
    var opSections = op && op.sections && op.sections['cart-drawer'] && !op.sections.token ? op.sections : null;
    var work = opSections
      ? Promise.resolve([op.items && op.token ? op : null, opSections])
      : Promise.all([fetchCart(), fetchSectionsOnly()]);
    work
      .then(function (res) {
        try { console.log('[ship-prot] final render', seq, renderSeq, !!intencao, res[1] ? Object.keys(res[1]).map(function(k){return k+':'+(res[1][k]?res[1][k].length:'null')}).join(' ') : null); } catch (e) {}
        if (seq !== renderSeq || intencao) return;
        var cart = res[0];
        var cfg = readConfig();
        var vid = (cfg && cfg.variantId) || VARIANT_FALLBACK;
        var on = cart ? !!findProtectionLine(cart, vid) : !!lastDesiredOn;
        batching = false;
        hushObserver();
        if (res[1]) applySections(res[1]);
        // Guard against another script redrawing the drawer from stale data right after us.
        var finalSections = res[1];
        [400, 1200, 2500].forEach(function (ms) {
          setTimeout(function () {
            if (seq !== renderSeq || intencao || emVoo || !finalSections) return;
            var root = document.querySelector('cart-drawer [data-ship-prot-root]');
            var domOn = root ? root.getAttribute('data-ship-prot-in-cart') === 'true' : null;
            if (domOn !== null && domOn !== on) {
              try { console.log('[ship-prot] drawer overwritten by stale render; re-applying', ms); } catch (e) {}
              hushObserver();
              applySections(finalSections);
              setSwitchesState(on, priceFromConfig(readConfig()));
            }
          }, ms);
        });
        protKnown = on;
        desejoVisual = null;
        setSwitchesState(on, priceFromConfig(readConfig()));
        dispatchThemeEvents(cart);
      })
      .catch(function (err) {
        try { console.warn('[ship-prot] final render failed', err); } catch (e) {}
      })
      .then(function () {
        if (seq !== renderSeq) return;
        batching = false;
        emVoo = false;
        if (seq === renderSeq && !intencao) reconcileSubtotal();
        verifyDrawerOrReload(seq);
        lastSyncAt = Date.now();
        setSwitchesBusy(false);
        if (intencao) processIntention();
      });
  }

  /**
   * Core reconciliation — auto-add, opt-out, orphan protection, qty clamp.
   */
  function reconcile(options) {
    options = options || {};
    // Do not fight an in-flight toggle, a pending intention, or Zipify checkout.
    if (checkoutGoing && !options.force) return Promise.resolve(null);
    if ((emVoo || intencao) && !options.force) return Promise.resolve(null);

    var cfg = readConfig();
    var variantId = (cfg && cfg.variantId) || VARIANT_FALLBACK;
    var optOut = hasOptOut();
    var optInMarket = cfg ? cfg.optInMarket : false;
    var price = cfg && cfg.priceLabel;

    function finish(result) {
      emVoo = false;
      lastSyncAt = Date.now();
      if (result && result.items) {
        protKnown = !!findProtectionLine(result, variantId);
      }
      if (intencao) processIntention();
      return result;
    }

    function runWithCart(cart) {
      var line = findProtectionLine(cart, variantId);
      var others = otherItemCount(cart, variantId);

      if (others === 0) setOptOut(false);

      if (line && others === 0) {
        protKnown = false;
        return removeProtection(cart, variantId).then(function (updated) {
          setSwitchesState(false, price);
          return updated;
        });
      }

      if (others === 0) {
        protKnown = false;
        setSwitchesState(false, price);
        return cart;
      }

      if (line && line.quantity > 1) {
        protKnown = true;
        return ensureQtyOne(cart, variantId).then(function (updated) {
          setSwitchesState(true, price);
          return updated;
        });
      }

      if (line) {
        protKnown = true;
        setSwitchesState(true, price);
        return cart;
      }

      setSwitchesState(false, price);

      if (options.skipAutoAdd) return cart;

      if (!optOut && !optInMarket) {
        protKnown = true;
        setSwitchesState(true, price);
        return addProtection(variantId, cart).then(function (updated) {
          setSwitchesState(true, price);
          return updated;
        });
      }

      return cart;
    }

    // Drawer HTML is source of truth when we are not mid-request.
    if (!emVoo && cfg && cfg.otherCount > 0 && !cfg.inCart) {
      protKnown = false;
    }

    // Fast path: drawer markup already says protection is in, qty 1.
    if (cfg && cfg.inCart && cfg.qty <= 1 && cfg.otherCount > 0 && protKnown !== false) {
      protKnown = true;
      setSwitchesState(true, price);
      lastSyncAt = Date.now();
      return Promise.resolve(null);
    }

    // Fast auto-add from drawer markup — skip the extra cart.js round-trip.
    if (
      !options.skipAutoAdd &&
      cfg &&
      cfg.otherCount > 0 &&
      !cfg.inCart &&
      !optOut &&
      !optInMarket &&
      protKnown !== true
    ) {
      emVoo = true;
      protKnown = true;
      setSwitchesState(true, price);
      return addProtection(variantId, { items: [] })
        .then(function (updated) {
          setSwitchesState(true, price);
          return updated;
        })
        .catch(function (err) {
          protKnown = null;
          if (window.console && console.warn) console.warn('[ship-prot]', err);
          return fetchCart().then(runWithCart);
        })
        .then(finish);
    }

    var known = cartFromPayload(options.cart);
    emVoo = true;
    var start = known ? Promise.resolve(known) : fetchCart();
    return start
      .then(runWithCart)
      .catch(function (err) {
        if (window.console && console.warn) {
          console.warn('[ship-prot]', err);
        }
        return null;
      })
      .then(finish);
  }

  function scheduleReconcile(opts) {
    if (checkoutGoing && !(opts && opts.force)) return;
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      syncTimer = null;
      if (checkoutGoing && !(opts && opts.force)) return;
      if (skipObserver && !(opts && opts.force)) return;
      if (emVoo && !(opts && opts.force)) return;
      // Pending user intent takes priority over background sync after re-render.
      if (reaplicarEstadoAposRender()) return;
      // Debounce Zipify / theme cart.js spam. Observer ticks are cheaper to skip.
      var quiet = opts && opts.immediate ? 150 : 400;
      if (Date.now() - lastSyncAt < quiet && !(opts && opts.force)) return;
      reconcile(opts);
    }, opts && opts.immediate ? 0 : 80);
  }

  function onToggleClick(event) {
    var btn = event.target && event.target.closest ? event.target.closest('[data-ship-prot-switch]') : null;
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    if (cartPageLocked) return;

    var cfg = readConfig(btn.closest('[data-ship-prot-root]')) || readConfig();
    var price = priceFromConfig(cfg);

    // Base the toggle on optimistic / pending state when the DOM node was just replaced.
    var currentlyOn;
    if (emVoo && desejoVisual !== null) {
      currentlyOn = !!desejoVisual;
    } else if (intencao) {
      currentlyOn = intencao === 'add';
    } else {
      currentlyOn = btn.getAttribute('aria-checked') === 'true';
    }
    var wantOn = !currentlyOn;

    lastClickAt = Date.now();
    // Immediate visual feedback (before network).
    desejoVisual = wantOn;
    setSwitchesState(wantOn, price);
    if (!isCartPage()) optimisticDrawer(wantOn);

    // Last-wins intention — never drop the click while a request is in flight.
    intencao = wantOn ? 'add' : 'remove';
    if (isCartPage()) cartPageLocked = true; // page reloads after this click; ignore further clicks

    if (emVoo) return;

    processIntention();
  }

  // 1. Document-level delegation — survives full drawer re-renders
  document.addEventListener('click', onToggleClick, true);

  function markCheckoutGoing(event) {
    var t = event.target && event.target.closest ? event.target.closest('[name="checkout"], #CartDrawer-Checkout, [href="/checkout"], [href*="/checkouts/"]') : null;
    if (!t) return;
    checkoutGoing = true;
    skipObserver = true;
  }
  document.addEventListener('click', markCheckoutGoing, true);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form) return;
    if (form.querySelector('[name="checkout"]') || (form.getAttribute && form.getAttribute('action') && form.getAttribute('action').indexOf('/cart') !== -1 && form.querySelector('[name="checkout"]'))) {
      checkoutGoing = true;
      skipObserver = true;
    }
  }, true);

  // Keyboard: role=switch is a button, so Enter/Space work natively; keep click path only.

  // External cart mutations (apps / theme)
  document.addEventListener('cart:updated', function (e) {
    if (selfEvent || checkoutGoing) return;
    if (e && e.detail && e.detail.source === 'ship-prot') return;
    var incoming = cartFromPayload(e && e.detail);
    if (incoming && !emVoo) {
      var cfgNow = readConfig();
      var vid = (cfgNow && cfgNow.variantId) || VARIANT_FALLBACK;
      protKnown = !!findProtectionLine(incoming, vid);
    }
    scheduleReconcile({ skipAutoAdd: false, cart: incoming, immediate: true });
  });
  document.addEventListener('cart:refresh', function (e) {
    if (selfEvent || checkoutGoing) return;
    scheduleReconcile({ skipAutoAdd: false, cart: cartFromPayload(e && e.detail) });
  });

  try {
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (payload) {
        if (selfEvent || checkoutGoing) return;
        if (payload && payload.source === 'ship-prot') return;
        scheduleReconcile({ skipAutoAdd: false, cart: cartFromPayload(payload), immediate: true });
      });
    }
  } catch (e) {
    /* ignore */
  }

  // When the drawer re-renders our root, re-run reconcile (covers add-to-cart from PDP)
  var moTimer = null;
  var observer = new MutationObserver(function () {
    if (checkoutGoing || skipObserver || emVoo) return;
    if (moTimer) clearTimeout(moTimer);
    moTimer = setTimeout(function () {
      if (checkoutGoing || skipObserver || emVoo) return;
      if (!getRoot()) return;
      scheduleReconcile({ skipAutoAdd: false });
    }, 80);
  });

  function startObserver() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      observer.observe(drawer, { childList: true, subtree: true });
      return;
    }
    if (!document.body) return;
    observer.observe(document.body, { childList: true, subtree: true });
  }

  /**
   * /cart page only: when the theme changes the cart (e.g. removes the last product),
   * drop an orphan protection line in the same flow and reload right away.
   */
  function hookCartPageFetch() {
    if (!isCartPage() || !window.fetch || window.__shipProtFetchHooked) return;
    window.__shipProtFetchHooked = true;
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var hdrs = (init && init.headers) || {};
      var own = hdrs && (hdrs['X-Ship-Prot'] || (typeof hdrs.get === 'function' && hdrs.get('X-Ship-Prot')));
      var p = origFetch.apply(this, arguments);
      if (own || !/\/cart\/(change|update)(\.js)?/.test(url)) return p;
      return p.then(function (res) {
        return res.clone().json().then(function (data) {
          var cfg = readConfig();
          var vid = (cfg && cfg.variantId) || VARIANT_FALLBACK;
          var cart = cartFromPayload(data);
          if (!cart) return res;
          var line = findProtectionLine(cart, vid);
          var others = otherItemCount(cart, vid);
          if (others === 0) setOptOut(false);
          if (line && others === 0) {
            emVoo = true;
            return postJSON(routes().change, { id: line.key || line.id, quantity: 0 }).then(function () {
              window.location.reload();
              return new Promise(function (resolve) { setTimeout(function () { resolve(res); }, 4000); });
            }, function () { emVoo = false; return res; });
          }
          return res;
        }, function () { return res; });
      });
    };
  }

  function boot() {
    hookCartPageFetch();
    reopenDrawerIfFlagged();
    startObserver();
    // Initial auto-add / cleanup
    scheduleReconcile({ skipAutoAdd: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
